/* app/js/src/components/reports/missing-sub-titles-report/missing-sub-titles-report.component.scss */
.report-header {
  color: #232f3a;
  width: 700px;
  padding-left: 20px;
}
.preloader {
  text-align: center;
}
.row-header {
  color: #879baf;
  font-weight: normal !important;
}
.goto-media {
  font-family: OpenSans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #879baf;
}
.report-header-dark {
  color: #232f3a;
  width: 550px;
  padding-left: 20px;
  float: left;
}
.report-header-light {
  color: #879baf;
  font-weight: normal !important;
}
.report-header-row {
  height: 65px;
}
.no-gaps-message {
  background-color: white;
  height: 335px;
  text-align: center;
}
.no-gaps-message .message {
  font-size: 24px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #232f3a;
  padding-top: 50px;
}
.no-gaps-message .message b {
  font-weight: 600;
}
.success-icon {
  display: inline-block;
  margin-top: 40px;
}
/*# sourceMappingURL=missing-sub-titles-report.component.css.map */
